import styled from "styled-components";

import {
  Option as OptionBase,
  SelectInput
} from "../../../SelectField/components/SelectInput";

export const COUNTRY_CODE_SELECT_WIDTH = 72;

export const Select = styled(SelectInput)`
  width: ${COUNTRY_CODE_SELECT_WIDTH}px;
`;

export const Option = styled(OptionBase)``;
